import ACHMethod from './ach-method';

export default ACHMethod;
